"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  PaginateFilter1Alternate: ['paginate-filter-1-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM6,18.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,6,2H21.5a.5.5,0,0,1,.5.5V18a.5.5,0,0,1-.5.5Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z', 'M16.5,13.5H15.25a.25.25,0,0,1-.25-.25V7a1.5,1.5,0,0,0-2.436-1.172l-1.688,1.35a1,1,0,1,0,1.249,1.563l.875-.7v5.21a.25.25,0,0,1-.25.25H11.5a1,1,0,0,0,0,2h5a1,1,0,0,0,0-2Z']],
  PaginateFilter9Alternate: ['paginate-filter-9-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm-.145,18.354a.5.5,0,0,1-.354.146H6a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,6,2H21.5a.5.5,0,0,1,.5.5V18A.5.5,0,0,1,21.855,18.351Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z', 'M13.5,5a3.5,3.5,0,1,0,1.359,6.726A2,2,0,0,1,13,13h-.5a1,1,0,0,0,0,2H13a4,4,0,0,0,4-4V8.5A3.5,3.5,0,0,0,13.5,5Zm0,5A1.5,1.5,0,1,1,15,8.5,1.5,1.5,0,0,1,13.5,10Z']],
  PaginateFilterAudioAlternate: ['paginate-filter-audio-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16,5.5c-.92,0-1.664-1.049-1.668-1.054a1.077,1.077,0,0,0-.919-.428A1.031,1.031,0,0,0,12.5,5v5.25a.25.25,0,0,1-.25.25H11.5a3,3,0,1,0,3,3V7.511a.25.25,0,0,1,.108-.206.253.253,0,0,1,.231-.028A3.229,3.229,0,0,0,16,7.5a.745.745,0,0,1,.67.491,1.188,1.188,0,0,1-.377,1.3A1,1,0,0,0,17.707,10.7a3.17,3.17,0,0,0,.811-3.48A2.739,2.739,0,0,0,16,5.5Z', 'M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm-.145,18.354a.5.5,0,0,1-.354.146H6a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,6,2H21.5a.5.5,0,0,1,.5.5V18A.5.5,0,0,1,21.855,18.351Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  PaginateFilterMailAlternate: ['paginate-filter-mail-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,1.5H5.5a2,2,0,0,0-2,2V17a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V3.5A2,2,0,0,0,22,1.5Zm-.5,2A.5.5,0,0,1,22,4v.2a.5.5,0,0,1-.223.416L14.255,9.625a.5.5,0,0,1-.544.007L5.733,4.594A.5.5,0,0,1,5.5,4.171V4A.5.5,0,0,1,6,3.5ZM6,17a.5.5,0,0,1-.5-.5V7.719A.5.5,0,0,1,6.267,7.3l7.2,4.546A1,1,0,0,0,14,12a1.009,1.009,0,0,0,.555-.168l6.668-4.446A.5.5,0,0,1,22,7.8v8.7a.5.5,0,0,1-.5.5Z', 'M19.5,20.5H2.5A.5.5,0,0,1,2,20V6A1,1,0,0,0,0,6V20.5a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  PaginateFilterCameraAlternate: ['paginate-filter-camera-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.472,7.115a1,1,0,0,0-1.027.05l-1.164.777a.253.253,0,0,1-.225.027A.25.25,0,0,1,16.9,7.8,2.5,2.5,0,0,0,14.5,6H10A2.5,2.5,0,0,0,7.5,8.5v4A2.5,2.5,0,0,0,10,15h4.5a2.5,2.5,0,0,0,2.4-1.806.25.25,0,0,1,.379-.138l1.164.776A1,1,0,0,0,20,13V8A1,1,0,0,0,19.472,7.115Z', 'M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm-.145,18.354a.5.5,0,0,1-.354.146H6a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,6,2H21.5a.5.5,0,0,1,.5.5V18A.5.5,0,0,1,21.855,18.351Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  PaginateFilterHeartAlternate: ['paginate-filter-heart-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.858,5.2a3.114,3.114,0,0,0-2.73.881l-.377.376-.377-.377a3.148,3.148,0,0,0-4.459,4.444l4.475,4.669a.5.5,0,0,0,.721,0l4.467-4.66a3.145,3.145,0,0,0,.59-3.634A3.112,3.112,0,0,0,16.858,5.2Z', 'M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm-.145,18.354a.5.5,0,0,1-.354.146H6a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,6,2H21.5a.5.5,0,0,1,.5.5V18A.5.5,0,0,1,21.855,18.351Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  Filter5: ['filter-5', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,2a2,2,0,0,0-2-2H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2ZM12.25,9a.25.25,0,0,0,.25.25h2a2.75,2.75,0,0,1,0,5.5h-3a.75.75,0,0,1,0-1.5h3a1.25,1.25,0,0,0,0-2.5h-2A1.752,1.752,0,0,1,10.75,9V6a.75.75,0,0,1,.75-.75h5a.75.75,0,0,1,0,1.5h-4a.25.25,0,0,0-.25.25Z', 'M20.5,23a1,1,0,0,0-1-1H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5A1,1,0,0,0,20.5,23Z']],
  Filter6: ['filter-6', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm-8,14.75a3.254,3.254,0,0,1-3.25-3.25V9a3.754,3.754,0,0,1,3.75-3.75H15a.75.75,0,0,1,0,1.5h-.5a2.245,2.245,0,0,0-2.225,2.007A3.215,3.215,0,0,1,14,8.247a3.25,3.25,0,0,1,0,6.5Z', 'M12.250 11.497 A1.750 1.750 0 1 0 15.750 11.497 A1.750 1.750 0 1 0 12.250 11.497 Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  Filter7: ['filter-7', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm-5.385,7.56L13.7,14.778a.75.75,0,1,1-1.39-.562l2.677-6.625a.25.25,0,0,0-.232-.344H12a.25.25,0,0,0-.25.25V8a.75.75,0,0,1-1.5,0V7a1.251,1.251,0,0,1,1.25-1.25h3.962a1.3,1.3,0,0,1,1.1.6A1.207,1.207,0,0,1,16.615,7.557Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  Filter8: ['filter-8', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.750 7.497 A0.750 0.750 0 1 0 14.250 7.497 A0.750 0.750 0 1 0 12.750 7.497 Z', 'M11.750 11.497 A1.750 1.750 0 1 0 15.250 11.497 A1.750 1.750 0 1 0 11.750 11.497 Z', 'M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm-8.5,14.75a3.249,3.249,0,0,1-1.821-5.94A2.23,2.23,0,0,1,11.25,7.5a2.25,2.25,0,0,1,4.5,0,2.23,2.23,0,0,1-.429,1.31,3.249,3.249,0,0,1-1.821,5.94Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  Filter3: ['filter-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM17.25,12a2.752,2.752,0,0,1-2.75,2.75h-3a.75.75,0,0,1,0-1.5h3a1.25,1.25,0,0,0,0-2.5H13a.75.75,0,0,1,0-1.5h1.5a1.25,1.25,0,0,0,0-2.5h-3a.75.75,0,0,1,0-1.5h3A2.749,2.749,0,0,1,16.386,10,2.747,2.747,0,0,1,17.25,12Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  Filter4: ['filter-4', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.75,11a.25.25,0,0,0,.25.25h3a.25.25,0,0,0,.25-.25V7.124a.25.25,0,0,0-.313-.242A4.257,4.257,0,0,0,11.75,11Z', 'M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM16.75,14a.75.75,0,0,1-1.5,0v-1.25H11a.75.75,0,0,1-.75-.75V11A5.757,5.757,0,0,1,16,5.247a.75.75,0,0,1,.75.75Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  Filter9: ['filter-9', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM16.75,11.5A3.754,3.754,0,0,1,13,15.247h-.5a.75.75,0,0,1,0-1.5H13a2.245,2.245,0,0,0,2.225-2.007,3.215,3.215,0,0,1-1.725.507A3.25,3.25,0,1,1,16.75,9Z', 'M11.750 8.997 A1.750 1.750 0 1 0 15.250 8.997 A1.750 1.750 0 1 0 11.750 8.997 Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  FilterVideo: ['filter-video', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM17.977,11.283l-5.922,3.384h0a1.04,1.04,0,0,1-1.554-.9V7a1.04,1.04,0,0,1,1.554-.9l5.923,3.384a1.038,1.038,0,0,1,0,1.8Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  PaginateFilter2Alternate: ['paginate-filter-2-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm-.145,18.354a.5.5,0,0,1-.354.146H6a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,6,2H21.5a.5.5,0,0,1,.5.5V18A.5.5,0,0,1,21.855,18.351Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z', 'M16.5,13.5H13.645l1.609-1.42c.972-.855,2.073-1.825,1.676-3.779A3.5,3.5,0,0,0,10,9a1,1,0,0,0,2,0,1.5,1.5,0,0,1,2.97-.3c.16.788-.083,1.04-1.037,1.88l-3.6,3.171A1,1,0,0,0,11,15.5h5.5a1,1,0,0,0,0-2Z']],
  PaginateFilter3Alternate: ['paginate-filter-3-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm-.145,18.354a.5.5,0,0,1-.354.146H6a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,6,2H21.5a.5.5,0,0,1,.5.5V18A.5.5,0,0,1,21.855,18.351Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z', 'M14.5,5.5h-3a1,1,0,0,0,0,2h3a1,1,0,0,1,0,2H13a1,1,0,0,0,0,2h1.5a1,1,0,0,1,0,2h-3a1,1,0,0,0,0,2h3a3,3,0,0,0,2.234-5,3,3,0,0,0-2.234-5Z']],
  PaginateFilter7Alternate: ['paginate-filter-7-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,2a2,2,0,0,0-2-2H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2ZM22,18a.5.5,0,0,1-.5.5H6a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,6,2H21.5a.5.5,0,0,1,.5.5Z', 'M20.5,23a1,1,0,0,0-1-1H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5A1,1,0,0,0,20.5,23Z', 'M15.961,5.5H12A1.5,1.5,0,0,0,10.5,7V8a1,1,0,1,0,2,0v-.25a.25.25,0,0,1,.25-.25h2.129a.249.249,0,0,1,.232.344l-2.538,6.281a1,1,0,1,0,1.854.75l2.91-7.2a1.459,1.459,0,0,0-.063-1.458A1.558,1.558,0,0,0,15.961,5.5Z']],
  PaginateFilter8Alternate: ['paginate-filter-8-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm-.145,18.354a.5.5,0,0,1-.354.146H6a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,6,2H21.5a.5.5,0,0,1,.5.5V18A.5.5,0,0,1,21.855,18.351Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z', 'M15.741,8.831a2.75,2.75,0,1,0-4.482,0,3.5,3.5,0,1,0,4.482,0ZM12.75,7.247A.75.75,0,1,1,13.5,8,.75.75,0,0,1,12.75,7.247ZM13.5,13A1.5,1.5,0,1,1,15,11.5,1.5,1.5,0,0,1,13.5,13Z']],
  PaginateFilter4Alternate: ['paginate-filter-4-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm-.145,18.354a.5.5,0,0,1-.354.146H6a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,6,2H21.5a.5.5,0,0,1,.5.5V18A.5.5,0,0,1,21.855,18.351Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z', 'M16,5.5a6.007,6.007,0,0,0-6,6v1a1,1,0,0,0,1,1h4v1a1,1,0,0,0,2,0v-8A1,1,0,0,0,16,5.5Zm-1,5.75a.25.25,0,0,1-.25.25H12.258a.25.25,0,0,1-.249-.266,4.01,4.01,0,0,1,2.657-3.5A.251.251,0,0,1,15,7.962Z']],
  PaginateFilter5Alternate: ['paginate-filter-5-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm-.145,18.354a.5.5,0,0,1-.354.146H6a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,6,2H21.5a.5.5,0,0,1,.5.5V18A.5.5,0,0,1,21.855,18.351Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z', 'M16.5,7.5a1,1,0,0,0,0-2h-5a1,1,0,0,0-1,1v3a2,2,0,0,0,2,2h2a1,1,0,0,1,0,2h-3a1,1,0,0,0,0,2h3a3,3,0,0,0,0-6H12.75a.25.25,0,0,1-.25-.25v-1.5a.25.25,0,0,1,.25-.25Z']],
  PaginateFilterTextAlternate: ['paginate-filter-text-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.000 4.497 L19.500 4.497 L19.500 6.997 L8.000 6.997 Z', 'M8.000 8.997 L19.500 8.997 L19.500 11.497 L8.000 11.497 Z', 'M8.000 13.497 L14.500 13.497 L14.500 15.997 L8.000 15.997 Z', 'M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm-.145,18.354a.5.5,0,0,1-.354.146H6a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,6,2H21.5a.5.5,0,0,1,.5.5V18A.5.5,0,0,1,21.855,18.351Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  PaginateFilterVideoAlternate: ['paginate-filter-video-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.976,9.172,12.053,5.788a1.039,1.039,0,0,0-1.554.9v6.767a1.039,1.039,0,0,0,1.554.9h0l5.922-3.385a1.038,1.038,0,0,0,0-1.8Z', 'M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm-.145,18.354a.5.5,0,0,1-.354.146H6a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,6,2H21.5a.5.5,0,0,1,.5.5V18A.5.5,0,0,1,21.855,18.351Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  PaginateFilterPlusAlternate: ['paginate-filter-plus-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.25,8.247H16A.25.25,0,0,1,15.75,8V5.747a1.5,1.5,0,0,0-1.5-1.5h-1a1.5,1.5,0,0,0-1.5,1.5V8a.25.25,0,0,1-.25.25H9.25a1.5,1.5,0,0,0-1.5,1.5v1a1.5,1.5,0,0,0,1.5,1.5H11.5a.25.25,0,0,1,.25.25v2.25a1.5,1.5,0,0,0,1.5,1.5h1a1.5,1.5,0,0,0,1.5-1.5V12.5a.25.25,0,0,1,.25-.25h2.25a1.5,1.5,0,0,0,1.5-1.5v-1A1.5,1.5,0,0,0,18.25,8.247Z', 'M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm-.145,18.354a.5.5,0,0,1-.354.146H6a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,6,2H21.5a.5.5,0,0,1,.5.5V18A.5.5,0,0,1,21.855,18.351Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  Filter11: ['filter-1_1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,2a2,2,0,0,0-2-2H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2ZM12.468,8.042a.75.75,0,1,1-.936-1.172L13.22,5.52a1.25,1.25,0,0,1,2.03.977V13a.25.25,0,0,0,.25.25H17a.75.75,0,0,1,0,1.5H12a.75.75,0,0,1,0-1.5h1.5a.25.25,0,0,0,.25-.25V7.016Z', 'M20.5,23a1,1,0,0,0-1-1H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5A1,1,0,0,0,20.5,23Z']],
  Filter21: ['filter-2_1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm-5.5,14.75H11a.75.75,0,0,1-.5-1.313l3.594-3.17c.975-.86,1.3-1.2,1.117-2.118A1.75,1.75,0,0,0,11.75,8.5a.75.75,0,0,1-1.5,0,3.25,3.25,0,0,1,6.435-.649c.368,1.811-.63,2.691-1.6,3.542l-2.106,1.857H16.5a.75.75,0,0,1,0,1.5Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  PaginateFilterPlus1Alternate: ['paginate-filter-plus-1-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.5,9.5h-.75a.25.25,0,0,1-.25-.25V8.5a1,1,0,0,0-2,0v.75a.25.25,0,0,1-.25.25H8.5a1,1,0,0,0,0,2h.75a.25.25,0,0,1,.25.25v.75a1,1,0,0,0,2,0v-.75a.25.25,0,0,1,.25-.25h.75a1,1,0,0,0,0-2Z', 'M19.015,5.14a1,1,0,0,0-1.139.076l-2.5,2a1,1,0,1,0,1.249,1.563l.4-.318-1,5.352a1,1,0,0,0,1.966.369l1.5-8A1,1,0,0,0,19.015,5.14Z', 'M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm-.145,18.354a.5.5,0,0,1-.354.146H6a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,6,2H21.5a.5.5,0,0,1,.5.5V18A.5.5,0,0,1,21.855,18.351Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  FilterMail: ['filter-mail', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.852,10.016a.251.251,0,0,0,.272,0L23.74,3.6a.5.5,0,0,0,.212-.519A2,2,0,0,0,22,1.5H5.5A2,2,0,0,0,3.53,3.148a.5.5,0,0,0,.226.51Z', 'M14.956,11.261a1.75,1.75,0,0,1-1.9.024L4.267,5.737A.5.5,0,0,0,3.5,6.16V17a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.166a.5.5,0,0,0-.777-.416Z', 'M19.5,20.5H2.5A.5.5,0,0,1,2,20V6A1,1,0,0,0,0,6V20.5a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  FilterCamera: ['filter-camera', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM19.5,12.5a.5.5,0,0,1-.724.447l-2.105-1.053a.121.121,0,0,0-.115.005.119.119,0,0,0-.056.1,2,2,0,0,1-2,2H10a2,2,0,0,1-2-2V8a2,2,0,0,1,2-2h4.5a2,2,0,0,1,2,2,.119.119,0,0,0,.056.1.121.121,0,0,0,.115,0L18.776,7.05A.5.5,0,0,1,19.5,7.5Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  FilterHeart: ['filter-heart', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM18.152,10.44l-4.041,4.216a.5.5,0,0,1-.721,0L9.341,10.432A2.888,2.888,0,0,1,8.806,7.1a2.9,2.9,0,0,1,4.637-.753l.307.308.308-.306a2.894,2.894,0,0,1,4.636.751A2.892,2.892,0,0,1,18.152,10.44Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  FilterPlus: ['filter-plus', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM19.25,11a1,1,0,0,1-1,1h-2.5a.25.25,0,0,0-.25.25v2.5a1,1,0,0,1-1,1H13a1,1,0,0,1-1-1v-2.5a.25.25,0,0,0-.25-.25H9.25a1,1,0,0,1-1-1V9.5a1,1,0,0,1,1-1h2.5a.25.25,0,0,0,.25-.25v-2.5a1,1,0,0,1,1-1h1.5a1,1,0,0,1,1,1v2.5a.25.25,0,0,0,.25.25h2.5a1,1,0,0,1,1,1Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  FilterMusic: ['filter-music', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM19.25,11.5A2.5,2.5,0,1,1,16.75,9a2.475,2.475,0,0,1,1,.212V6a.251.251,0,0,0-.3-.245l-5,1.072a.25.25,0,0,0-.2.244V13.5h0A2.5,2.5,0,1,1,9.75,11a2.475,2.475,0,0,1,1,.212V7.069a1.76,1.76,0,0,1,1.383-1.711l5-1.071A1.75,1.75,0,0,1,19.25,6Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  FilterPicture: ['filter-picture', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM9.667,12.433a1,1,0,0,1,1.727-.108l.83,1.246a.25.25,0,0,0,.428-.021l2.437-4.527A.977.977,0,0,1,16,8.5a1,1,0,0,1,.878.574l3.578,7.6a.5.5,0,0,1-.453.713H8a.5.5,0,0,1-.447-.724ZM7.75,6.247a2,2,0,1,1,2,2A2,2,0,0,1,7.75,6.247Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  FilterPlus1: ['filter-plus-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,2a2,2,0,0,0-2-2H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2Zm-11.5,8.75h-1a.25.25,0,0,0-.25.25v1a.75.75,0,0,1-1.5,0V11a.25.25,0,0,0-.25-.25h-1a.75.75,0,0,1,0-1.5h1A.25.25,0,0,0,9.75,9V8a.75.75,0,0,1,1.5,0V9a.25.25,0,0,0,.25.25h1a.75.75,0,0,1,0,1.5Zm6.237-5.111-1.5,8a.75.75,0,0,1-1.474-.278l1.128-6.013-.922.738a.751.751,0,0,1-.938-1.172l2.5-2a.75.75,0,0,1,1.206.725Z', 'M20.5,23a1,1,0,0,0-1-1H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5A1,1,0,0,0,20.5,23Z']],
  FilterText1: ['filter-text_1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM14.5,15a.5.5,0,0,1-.5.5H9a.5.5,0,0,1-.5-.5V14a.5.5,0,0,1,.5-.5h5a.5.5,0,0,1,.5.5Zm5-4.5a.5.5,0,0,1-.5.5H9a.5.5,0,0,1-.5-.5v-1A.5.5,0,0,1,9,9H19a.5.5,0,0,1,.5.5Zm0-4.5a.5.5,0,0,1-.5.5H9A.5.5,0,0,1,8.5,6V5A.5.5,0,0,1,9,4.5H19a.5.5,0,0,1,.5.5Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  FilterAudio: ['filter-audio', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm-3.97,10.53a.75.75,0,0,1-1.06-1.06A1.4,1.4,0,0,0,17.4,7.892a1,1,0,0,0-.9-.645,3.176,3.176,0,0,1-1.391-.33.25.25,0,0,0-.359.225V13.5A2.75,2.75,0,1,1,12,10.747h1a.25.25,0,0,0,.25-.25V5a.75.75,0,0,1,1.374-.416A2.715,2.715,0,0,0,16.5,5.747a2.49,2.49,0,0,1,2.287,1.572A2.926,2.926,0,0,1,18.03,10.527Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  PaginateFilter10Alternate: ['paginate-filter-10-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,1.982a2,2,0,0,0-2-2H5.5a2,2,0,0,0-2,2v16.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2Zm-2,16a.5.5,0,0,1-.5.5H6a.5.5,0,0,1-.5-.5V2.482a.5.5,0,0,1,.5-.5H21.5a.5.5,0,0,1,.5.5Z', 'M20.5,22.982a1,1,0,0,0-1-1H2.5a.5.5,0,0,1-.5-.5v-17a1,1,0,0,0-2,0v17.5a2,2,0,0,0,2,2H19.5A1,1,0,0,0,20.5,22.982Z', 'M12,13.482h-.25a.25.25,0,0,1-.25-.25V6.982A1.5,1.5,0,0,0,9.063,5.811L7.375,7.16A1,1,0,0,0,8.624,8.723l.875-.7v5.21a.25.25,0,0,1-.25.25H8a1,1,0,1,0,0,2h4a1,1,0,1,0,0-2Z', 'M17,5.482a3.505,3.505,0,0,0-3.5,3.5v3a3.5,3.5,0,0,0,7,0v-3A3.5,3.5,0,0,0,17,5.482Zm1.5,6.5a1.5,1.5,0,0,1-3,0v-3a1.5,1.5,0,0,1,3,0Z']],
  PaginateFilter6Alternate: ['paginate-filter-6-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm-.145,18.354a.5.5,0,0,1-.354.146H6a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,6,2H21.5a.5.5,0,0,1,.5.5V18A.5.5,0,0,1,21.855,18.351Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z', 'M14,8.5a3.476,3.476,0,0,0-1.359.275A2,2,0,0,1,14.5,7.5H15a1,1,0,0,0,0-2h-.5a4.005,4.005,0,0,0-4,4V12A3.5,3.5,0,1,0,14,8.5Zm0,5A1.5,1.5,0,1,1,15.5,12,1.5,1.5,0,0,1,14,13.5Z']],
  PaginateFilterMusicAlternate: ['paginate-filter-music-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.581,4.292l-5,1.071A2.011,2.011,0,0,0,11,7.319v3.8a2.743,2.743,0,1,0,2,2.633h0V7.521a.25.25,0,0,1,.2-.245l4.5-.964a.25.25,0,0,1,.3.245V9.114a2.743,2.743,0,1,0,2,2.633v-5.5a2,2,0,0,0-2.419-1.955Z', 'M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm-.145,18.354a.5.5,0,0,1-.354.146H6a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,6,2H21.5a.5.5,0,0,1,.5.5V18A.5.5,0,0,1,21.855,18.351Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  FilterAndroid: ['filter-android', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM19.5,15A1.5,1.5,0,0,1,18,16.5H10A1.5,1.5,0,0,1,8.5,15V12a.5.5,0,0,1,.5-.5H19a.5.5,0,0,1,.5.5ZM19,10H9a.5.5,0,0,1-.5-.5A5.477,5.477,0,0,1,10.049,5.68l-1.1-1.17a.75.75,0,0,1,1.094-1.026l1.188,1.267a5.45,5.45,0,0,1,5.53,0l1.188-1.267a.751.751,0,0,1,1.094,1.028l-1.1,1.168A5.476,5.476,0,0,1,19.5,9.5.5.5,0,0,1,19,10Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z', 'M11.500 7.497 A0.750 0.750 0 1 0 13.000 7.497 A0.750 0.750 0 1 0 11.500 7.497 Z', 'M15.000 7.497 A0.750 0.750 0 1 0 16.500 7.497 A0.750 0.750 0 1 0 15.000 7.497 Z']],
  Filter10: ['filter-10', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.75,8.5v3a1.75,1.75,0,0,0,3.5,0v-3a1.75,1.75,0,0,0-3.5,0Z', 'M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM20.75,8.5v3a3.25,3.25,0,0,1-6.5,0v-3a3.25,3.25,0,0,1,6.5,0ZM8.968,8.045a.75.75,0,1,1-.936-1.172L9.72,5.523a1.25,1.25,0,0,1,2.03.977V13a.25.25,0,0,0,.25.25h.5a.75.75,0,0,1,0,1.5h-4a.75.75,0,0,1,0-1.5H10a.25.25,0,0,0,.25-.25V7.02Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  PaginateFilterAndroidAlternate: ['paginate-filter-android-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19,12H9a.5.5,0,0,0-.5.5v3A1.5,1.5,0,0,0,10,17h8a1.5,1.5,0,0,0,1.5-1.5v-3A.5.5,0,0,0,19,12Z', 'M19.23,5.181a1,1,0,1,0-1.459-1.367l-1.23,1.31a5.462,5.462,0,0,0-5.082,0L10.23,3.814A1,1,0,1,0,8.771,5.181l1.11,1.184A5.469,5.469,0,0,0,8.5,10a.5.5,0,0,0,.5.5H19a.5.5,0,0,0,.5-.5,5.469,5.469,0,0,0-1.381-3.632ZM12.25,8.747A.75.75,0,1,1,13,8,.75.75,0,0,1,12.25,8.747Zm3.5,0A.75.75,0,1,1,16.5,8,.75.75,0,0,1,15.75,8.747Z', 'M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm-.145,18.354a.5.5,0,0,1-.354.146H6a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,6,2H21.5a.5.5,0,0,1,.5.5V18A.5.5,0,0,1,21.855,18.351Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']],
  PaginateFilterPictureAlternate: ['paginate-filter-picture-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.500 6.247 A2.250 2.250 0 1 0 12.000 6.247 A2.250 2.250 0 1 0 7.500 6.247 Z', 'M16.916,8.71A1.027,1.027,0,0,0,16,8.158a1.007,1.007,0,0,0-.892.586L13.55,12.178a.249.249,0,0,1-.422.053l-.82-1.024a1,1,0,0,0-.813-.376,1.007,1.007,0,0,0-.787.426L7.59,15.71A.5.5,0,0,0,8,16.5H20a.5.5,0,0,0,.425-.237.5.5,0,0,0,.022-.486Z', 'M22,0H5.5a2,2,0,0,0-2,2V18.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm-.145,18.354a.5.5,0,0,1-.354.146H6a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,6,2H21.5a.5.5,0,0,1,.5.5V18A.5.5,0,0,1,21.855,18.351Z', 'M19.5,22H2.5a.5.5,0,0,1-.5-.5V4.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H19.5a1,1,0,0,0,0-2Z']]
};
exports["default"] = _default;